var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editMode)?_c('v-textarea',{ref:"textarea",attrs:{"error":_vm.field === _vm.fieldWithError,"resize":"vertical","rows":"9"},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}}):_c('vue-markdown',{staticClass:"markdown",attrs:{"html":false}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }